<div class="page-main">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-md-6" [ngClass]="{'hidden': loaderStatus}">
				<div class="login-box">
					@if (newPasswordProcess) {
					<div class="main-box with-row">
						<h2 class="title-balck" style=" padding-top: 35px">Reset your password</h2>
						<div style="padding-bottom: 15px;">for {{userEmail}}</div>
						<form (submit)="!resetPassrodForm?.invalid && resetPassword()">
							<div class="row">
								<div class="col-md">
									<mat-form-field class="full-width" appearance="outline">
										<input matInput type="password" [formControl]="password" [errorStateMatcher]="matcher"
											   placeholder="New password" (change)="passwordChanged()">
										@if (password.hasError('required')) {
										<mat-error>
											Password is <strong>required</strong>
										</mat-error>
										}
										@if (password.hasError('minlength')) {
										<mat-error>Password must have at least 8 characters</mat-error>
										}
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-md">
									<mat-form-field class="full-width" appearance="outline">
										<input matInput type="password" [formControl]="rePassword" [errorStateMatcher]="matcher"
											   placeholder="Confirm password" (change)="passwordChanged()">
										@if (rePassword.hasError('required')) {
										<mat-error>
											Password is <strong>required</strong>
										</mat-error>
										}
										@if (rePassword.invalid && !rePassword.hasError('required')) {
										<mat-error>
											Passwords don't match
										</mat-error>
										}
									</mat-form-field>
								</div>
							</div>
							<button mat-flat-button color="accent" type="submit" style="height: 50px !important; font-size: 18px !important;" class="full-width verify-btn">Save</button>
						</form>
					</div>
					}

					@if (!newPasswordProcess) {
					<div class="main-box">
						<h2 class="title title-balck" style="padding-top: 35px">Password changed!</h2>
						<div>Your password has been changed.</div>
						<div style="margin-bottom: 15px">You can now sign in with your new password.</div>
						<button (click)="gotoSignIn()" mat-flat-button color="accent" type="button" style="height: 50px !important; font-size: 18px !important;"  class="full-width verify-btn">Sign In</button>
					</div>
					}
				</div>
			</div>
		</div>
	</div>
</div>

    @if (loaderStatus) {
<div class="loader-box">
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
</div>
    }
